module.exports = __webpack_public_path__ + "img/telecom_recs.b8cb90a2.png";